module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location-08d104e575da70277e5a6515b2f29044.webp";